import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Modal, titanium, text, cloud, steel } from '@rover/react-bootstrap'
import DeviceDetailsAttributesView from './DeviceDetailsAttributesView'

class DeviceDetailsModal extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { isOpen, onRequestClose, dataGridRows, index, allColumns } = this.props

        return (
            <Modal
                isOpen={isOpen}
                onRequestClose={() => onRequestClose()}
                style={{
                    content: {
                        backgroundColor: 'white',
                        padding: 0,
                        width: 'auto',
                        overflow: 'hidden',
                    },
                    overlay: {
                        zIndex: 2,
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    },
                }}
                hoverStyle={{
                    backgroundColor: titanium,
                }}
                bodyOpenClassName="SegmentSelections"
            >
                <div
                    style={{
                        minHeight: 110,
                        maxHeight: 450,
                        width: 350,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div
                        style={{
                            height: 50,
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: cloud,
                            paddingLeft: 30,
                            color: steel,
                            fontSize: 14,
                            ...text,
                            fontWeight: 600,
                        }}
                    >
                        Device Details
                    </div>
                    <DeviceDetailsAttributesView
                        dataGridRows={dataGridRows}
                        index={index}
                        allColumns={allColumns}
                        handleCellEnter={this.props.handleCellEnter}
                        handleCellLeave={this.props.handleCellLeave}
                    />
                </div>
            </Modal>
        )
    }
}

DeviceDetailsModal.propTypes = {
    allColumns: PropTypes.arrayOf(
        PropTypes.shape({
            attribute: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            __typename: PropTypes.string.isRequired,
            selector: PropTypes.string.isRequired,
            group: PropTypes.string.isRequired,
        })
    ).isRequired,
    dataGridRows: PropTypes.array,
    handleCellEnter: PropTypes.func.isRequired,
    handleCellLeave: PropTypes.func.isRequired,
    index: PropTypes.number,
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    selectedView: PropTypes.string,
    updateDataGridRows: PropTypes.func,
    updateSelectedView: PropTypes.func.isRequired,
}

DeviceDetailsModal.defaultProps = {
    dataGridRows: [],
    isOpen: false,
    onRequestClose: () => null,
    index: 0,
    allColumns: [],
    updateDataGridRows: () => null,
    selectedView: 'Attributes',
}

export default DeviceDetailsModal
